export default __webpack_public_path__ + "static/media/1.blur.cfa35eda.PNG";